import { render, staticRenderFns } from "./CmgNutritionCalculatorIngredientsBanner.vue?vue&type=template&id=0c88cd00&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-ingredients-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-ingredients-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorIngredientsBanner.vue?vue&type=style&index=0&id=0c88cd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88cd00",
  null
  
)

export default component.exports